export default __webpack_public_path__ + "static/media/blog-five1.ea8b875e.jpg";